import { Jobibot, Tooltip } from '../../rapid-ui'

export type InstagramOverlayProps = { showTooltips?: boolean }

export function InstagramOverlay({ showTooltips = true }: InstagramOverlayProps) {
	return (
		<div data-render-exclude={true} className="absolute inset-2 pointer-events-none">
			<div className="h-[3px] bg-white/20 w-full rounded-full">
				<div className="h-full w-1/4 bg-white rounded-full" />
			</div>
			<div className="flex items-center mt-2">
				<div className="bg-white rounded-full p-1.5">
					<Jobibot size={28} />
				</div>
				<div className="flex flex-col ml-3 gap-0 text-white">
					<span className="font-medium">Jobilla</span>
					<span className="text-xs opacity-70">Sponsored</span>
				</div>

				<div className="flex-1" />

				<div className="p-4 text-white">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 14 14"
						id="Horizontal-Menu--Streamline-Core"
						height={18}
						width={18}
					>
						<g id="horizontal-menu--navigation-dots-three-circle-button-horizontal-menu">
							<path
								id="Union"
								fill="currentColor"
								fillRule="evenodd"
								d="M4 7c0 1.10457 -0.89543 2 -2 2 -1.104569 0 -2 -0.89543 -2 -2s0.895431 -2 2 -2c1.10457 0 2 0.89543 2 2Zm5 0c0 1.10457 -0.89543 2 -2 2s-2 -0.89543 -2 -2 0.89543 -2 2 -2 2 0.89543 2 2Zm3 2c1.1046 0 2 -0.89543 2 -2s-0.8954 -2 -2 -2 -2 0.89543 -2 2 0.8954 2 2 2Z"
								clipRule="evenodd"
								strokeWidth={1}
							/>
						</g>
					</svg>
				</div>
				<div className="p-4 text-white">
					<svg
						xmlns="http://www.w3.org/2000/svg"
						fill="none"
						viewBox="0 0 14 14"
						id="Delete-1--Streamline-Core"
						height={18}
						width={18}
					>
						<g id="delete-1--remove-add-button-buttons-delete-cross-x-mathematics-multiply-math">
							<path
								id="Union"
								fill="currentColor"
								fillRule="evenodd"
								d="M12.7082 2.70601c0.3905 -0.39053 0.3905 -1.02369 0 -1.41422 -0.3905 -0.39052 -1.0237 -0.39052 -1.4142 0l-4.29399 4.294 -4.294 -4.294c-0.39053 -0.39052 -1.02369 -0.39052 -1.41422 0 -0.39052 0.39053 -0.39052 1.02369 0 1.41422l4.294 4.294 -4.294 4.29399c-0.39052 0.3905 -0.39052 1.0237 0 1.4142 0.39053 0.3905 1.02369 0.3905 1.41422 0l4.294 -4.29398L11.294 12.7082c0.3905 0.3905 1.0237 0.3905 1.4142 0 0.3905 -0.3905 0.3905 -1.0237 0 -1.4142L8.41422 7.00001l4.29398 -4.294Z"
								clipRule="evenodd"
								strokeWidth={1}
							/>
						</g>
					</svg>
				</div>
			</div>

			<div className="absolute bottom-0 left-0 right-0 h-32 flex items-center justify-center">
				<div className="absolute top-[-10px] left-1/2 -translate-x-1/2 text-white text-4xl ">
					<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" height={32} width={32}>
						<g id="stat-1-fill">
							<path
								id="Union"
								fill="#ffffff"
								d="m18.207 13.793 -1.414 1.414L12 10.4141 7.20703 15.207l-1.41406 -1.414L12 7.58594z"
								strokeWidth={1}
							/>
						</g>
					</svg>
				</div>
				<div className="pointer-events-auto select-none cursor-not-allowed">
					<Tooltip
						disabled={!showTooltips}
						className="max-w-80 text-center"
						content="This is a placeholder element to help keep your ad within recommended safe zones. Meta will place their own call-to-action in this area."
					>
						<div className="text-grey-800 text-3xl font-medium bg-white py-3 px-4 rounded-lg flex items-center gap-1.5">
							<svg xmlns="http://www.w3.org/2000/svg" width={32} height={32} viewBox="0 0 32 32">
								<path
									d="M20.064 4.433696C18.341184000000002 4.672576 16.742592000000002 5.585312 15.683296 6.934848C15.449568 7.232608 15.163968 7.688128 14.985376 8.048L14.810656000000002 8.4 14.823584 8.672C14.838432000000001 8.983968 14.905056 9.145056 15.099808000000001 9.339808000000001C15.303136 9.543136 15.491200000000001 9.616192 15.808 9.614912C16.290399999999998 9.61296 16.498112000000003 9.459104 16.826432 8.860608000000001C17.08416 8.390816000000001 17.285376 8.120704 17.64704 7.75904C17.992608 7.413504 18.278944 7.195936 18.669919999999998 6.981888C20.274335999999998 6.103552 22.164576 6.201472 23.643456 7.239552C24.191168 7.6240000000000006 24.798624 8.32272 25.094208 8.90832C25.233952000000002 9.185120000000001 25.392256000000003 9.607296 25.468736 9.907008C25.667648000000003 10.686656000000001 25.652096 11.591968000000001 25.426464 12.368C25.322848000000004 12.724384 25.282944 12.814624 24.32976 14.848C23.426080000000002 16.775808 23.313119999999998 17.000896 23.061024000000003 17.376C22.869056 17.6616 22.337792 18.217312000000003 22.051616000000003 18.431808C20.644544000000003 19.486496 18.79936 19.681824000000002 17.222304 18.94304C16.4064 18.560831999999998 15.626656 17.837984000000002 15.170816 17.04128C15.096704 16.911744 14.966624 16.639456 14.881727999999999 16.43616C14.687327999999999 15.970592000000002 14.585632 15.840384 14.31088 15.70512C14.12688 15.614528 14.064064 15.6 13.856672000000001 15.6C13.658272000000002 15.6 13.584192 15.615616000000001 13.434848 15.68896C13.235456000000001 15.78688 13.065696 15.95552 12.95408 16.16656C12.895232 16.277856 12.88128 16.355744 12.880704 16.576C12.880096 16.816288 12.894208 16.884192 13.001792 17.158176C13.836 19.282975999999998 15.714176 20.849664 17.942304 21.279328000000003C19.854656 21.648096000000002 21.86944 21.150368 23.392 19.932992C24.147904 19.328608 24.745408 18.589248 25.195328000000003 17.701439999999998C25.737184000000003 16.632256 27.14064 13.583744000000001 27.276512 13.180832C27.544448 12.386304 27.632128 11.773152 27.607295999999998 10.867840000000001C27.578144 9.805504 27.378944 8.998144 26.915552 8.064C25.936096000000003 6.089600000000001 24.01968 4.720736 21.830368 4.431744C21.390944 4.373728 20.489248 4.37472 20.064 4.433696M12.96 10.74096C11.688672 10.862816 10.676736000000002 11.203968000000001 9.728 11.830592000000001C8.712992 12.501024 7.964096 13.353728 7.399136 14.482304000000001C7.056896 15.165951999999999 5.5147520000000005 18.472864 5.411136000000001 18.745248C5.010368000000001 19.798816 4.8938880000000005 21.147648 5.106944 22.267424C5.58384 24.774176 7.3957120000000005 26.786752 9.806111999999999 27.487232C10.57776 27.711456 11.607776 27.802048 12.378816 27.71344C14.659424000000001 27.451392000000002 16.635455999999998 26.090752000000002 17.626720000000002 24.099872C17.799808000000002 23.752192 17.807968000000002 23.724768 17.807328000000002 23.491872C17.806207999999998 23.076383999999997 17.591936 22.747296 17.211360000000003 22.57648C17.038016 22.498687999999998 16.986016 22.489984 16.770208 22.502464C16.336576 22.527584 16.10368 22.703744 15.826656000000002 23.216224C15.741088 23.374496 15.598656000000002 23.612000000000002 15.510144 23.744C15.289824000000001 24.072512 14.676096 24.676032 14.309792 24.924352C12.710624 26.008544 10.648512 26.007648000000003 9.029632 24.922048C8.674144 24.683648 8.052704 24.051104 7.809408 23.68C7.46288 23.151456 7.232992 22.600032 7.098208 21.974016C7.004224000000001 21.537568 6.9968 20.637344000000002 7.083776 20.224C7.150720000000001 19.905696 7.237439999999999 19.606336 7.334016 19.36C7.436736 19.097984 9.170112 15.411744 9.312736000000001 15.152000000000001C9.656512000000001 14.525888000000002 10.203072 13.930432000000001 10.817184 13.512992C11.29072 13.191104 12.026016 12.907552 12.676128 12.796096C13.362432000000002 12.678432 14.201312 12.745152000000001 14.883647999999999 12.971648C16.206336 13.410688 17.284063999999997 14.450624 17.779264 15.765696C17.820224 15.874432 17.8912 16.112032 17.937024 16.293696C17.982848 16.475360000000002 18.054816 16.683232 18.09696 16.755616000000003C18.411936 17.296768 19.174784 17.410016 19.636736000000003 16.984192C19.933216 16.710944 20.018880000000003 16.363232 19.90688 15.888C19.511328000000002 14.209952 18.515871999999998 12.776768 17.088 11.829472C16.671584 11.553216 15.969600000000002 11.211328 15.504 11.057984000000001C14.717376 10.798944 13.6904 10.670976000000001 12.96 10.74096"
									stroke="none"
									fill="currentColor"
									fillRule="evenodd"
									strokeWidth={0.032}
								/>
							</svg>
							Learn more
						</div>
					</Tooltip>
				</div>
			</div>
		</div>
	)
}
